import { observer } from 'mobx-react-lite'
import State from '../../../store/State'
import { content } from '../../../types/enums'
import countries from '../countries'
import closeIcon from '../../../assets/images/ic-close.svg'
import closeIconSmall from '../../../assets/images/ic-close-small.svg'
import styles from './Popup.module.css'

export const Popup = observer(() => {
  const index = State.getActiveCountryIndex()
  const country = index === content.NO ? undefined : countries[index]

  if (!country) return null

  const metrikaFilm = () => {
    //@ts-ignore
    ym(95340418, 'reachGoal', 'film')
  }

  const metrikaPage = () => {
    //@ts-ignore
    ym(95340418, 'reachGoal', 'statya')
  }

  const close = () => State.setActiveCountryIndex(content.NO)

  return (
    <div className={styles.backdrop}>
      <div className={styles.popup}>
        <div className={styles.media}>
          {country.photo
            ? <img className={styles.photo} src={country.photo} alt={country.title} key={country.photo} />
            : <div className={styles.photo + ' ' + styles.photo_empty} />}

          <a href={country.page} target='_blank' rel='noreferrer' className={styles.btn} onClick={metrikaPage}>
            Узнать больше о стране
          </a>

          {country.film
            ? <a href={country.film} target='_blank' rel='noreferrer' className={styles.btn} onClick={metrikaFilm}>
                Смотреть фильм
              </a>
            : <span className={styles.btn + ' ' + styles.btn_empty}>Смотреть фильм</span>}
        </div>

        <div className={styles.text}>
          <p className={styles.title}>{country.title}</p>
          <p className={styles.description}>{country.text}</p>
        </div>

        <button type='button' className={styles.close} onClick={close} aria-label='Закрыть'>
          <img src={closeIcon} alt='' className={styles.close_desktop} />
          <img src={closeIconSmall} alt='' className={styles.close_small} />
        </button>
      </div>
    </div>
  )
});

export default Popup
